<h4 class="float-left">Notificaties</h4>
<button type="button" style="outline:none;" class="close pull-right" aria-label="Close" (click)="close()">
  <span aria-hidden="true">×</span>
</button>
<div class="clearFix"></div>

<div *ngIf="accounts.length == 0 && gaps.length == 0">
  U heeft geen notificaties.
</div>

<div>
  <div *ngFor="let accountGaps of gaps">
    <div style="margin-bottom:5px;">
      {{accountGaps.account.accountCategory.name}} {{accountGaps.account.accountNumber}}
      <span *ngIf="accountGaps.periods.length == 1">heeft het volgende probleem:</span>
      <span *ngIf="accountGaps.periods.length >  1">heeft de volgende problemen:</span>
    </div>
    <ul>
      <li style="line-height:175%;" *ngFor="let period of accountGaps.periods">{{printPeriod(period)}}</li>
    </ul>
  </div>
</div>


<div>
<p *ngIf="accounts.length > 1">De volgende rekeningen hebben transacties die niet gecategoriseerd zijn:</p>
<p *ngIf="accounts.length == 1">De volgende rekening bevat transacties die niet gecategoriseerd zijn:</p>
<table class="table table-hover the-table" *ngIf="accounts != null && accounts.length >= 1">
  <thead>
    <tr>
      <th>Bewind</th>
      <th>Plaats</th>
      <th>Rekening</th>
      <th>Rekeningnummer</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let account of accounts" class="pointer" (click)="goTo(account)">
        <td>{{account.clientName}}</td>
        <td>{{account.clientCity}}</td>
        <td>{{account.accountCategory.name}}</td>
        <td>{{account.accountNumber}}</td>
        <td>
          <button  class="btn align-self-center float-right"
                   matBadgePosition="after"
                   matBadgeColor="accent"
                   [matBadge]="account.unassignedTransactionCount"
                   [matBadgeHidden]="account.unassignedTransactionCount == 0">
            transacties
          </button>
        </td>
      </tr>
  </tbody>
</table>
</div>
